
<script setup>
import { Toggle, Hints, Heading, Textarea, SectionHead } from '@components'
import DarkModeStore from '@o/store'
const { options } = DarkModeStore()
</script>

<template>
    <Row transparent gap="5">
        <SectionHead class="text-lg"> {{__('HTML Element', 'wp-dark-mode')}} 
            <template #description>
            {{__('Exclude dark mode on HTML tags, CSS class, CSS ids and more', 'wp-dark-mode')}}</template>
        </SectionHead>
        <Row class="flex-col sm:flex-row w-full" space>
            
            <Heading class="whitespace-nowrap w-auto">
                <Row inline center>
                    <Row locked :ProBadge="false"  class="whitespace-nowrap">{{__('Exclude Elements', 'wp-dark-mode')}}</Row> <ProBadge />
                </Row>
            </Heading>
            <Row style="width: 100%" locked>
                <Textarea class="font-mono text-sm  w-full" v-model="options.excludes_elements"
                    :placeholder="__('Enter HTML element selectors', 'wp-dark-mode')" />
                <Hints> Add comma separated HTML selector (eg. <code>div</code> , <code>#site-header</code> ) and dark mode will ignore these elements</Hints>
            </Row>
        </Row>
        <Row class="flex-col sm:flex-row w-full" space>
           
            <Heading class="whitespace-nowrap w-auto">
                <Row inline center>
                    <Row locked :ProBadge="false"  class="whitespace-nowrap">{{__('Include Elements', 'wp-dark-mode')}}</Row> <ProBadge />
                </Row>
            </Heading>
            <Row style="width: 100%" locked>
                <Textarea class="font-mono text-sm w-full" v-model="options.excludes_elements_includes"
                    placeholder="Enter HTML element selectors" />
                <Hints>'Add comma separated HTML selector (eg. <code>div</code> , <code>#site-header</code> ) and dark mode will be applied forcefully on these elements</Hints>
            </Row>
        </Row>
</Row></template>
